import { AxiosInstance } from "axios";

import { ParserUrlGenerator } from "./url-generator";
import {
  ParserParseRequest,
  ParserResponse,
} from "./repo";

import { downloadFile } from "@/shared/utils/file-helpers";

export interface ParserProjectRepository {
  parse(payload: ParserParseRequest): Promise<void>;
}

export class ParserHttpRepo implements ParserProjectRepository {
  constructor(
    private readonly axios: AxiosInstance,
    private readonly urlGenerator: ParserUrlGenerator
  ) {}

  async parse(payload: ParserParseRequest): Promise<void> {
    const { data } = await this.axios.post<ParserResponse>(
      this.urlGenerator.parse(),
      payload
    );

    downloadFile(
      data.docxFile,
      `${payload.fileName}.docx`,
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    );
  }
}
